import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@arco-design/web-react';

const { Title: ArcoTitle } = Typography;

// MUI Typography(variant h6, color primary) -> Arco Typography.Title heading 6.
export default function Title(props) {
  return (
    <ArcoTitle heading={6} style={{ color: 'rgb(var(--arcoblue-6))' }}>
      {props.children}
    </ArcoTitle>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};
